import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ExceptionManager } from "Core/logManager";
import { clientQuery, clientMutation } from "Core/data/GraphQLApi";
import { endpoints } from "Core/defaultValues";

const INIT_STATE = {
    openChangeStatus: false,
    changeStatusResponse: null,
    loadingChangeStatusDriver: false,
    errorChangeStatusDriver: null,
    items: [],
};

const route = "modules/settings/views/driver/components/changeStatus/redux/slice";

export const changeStatusDriver = createAsyncThunk(
  "settings/driver/components/changeStatus",
  async (payload, { rejectWithValue }) => {

    const {items, status} = payload;

    try {
      let data = await clientMutation(
        `
        mutation changeStatusDriver ($ids: [Int], $status: Int) {
            changeStatusDriver (
                ids: $ids, 
                status: $status
            )
        }
        `,
        {
            ids: items.map((driver) => driver.driverId),
            status: status
        },
        endpoints.GRAPHQL_GENERAL_V2
      );

      if (data?.changeStatusDriver) {
        return data;
      } else {
        throw "Error while changing status driver";
      }
    } catch (exc) {
      ExceptionManager(exc, route, "changeStatusDriver");
      return rejectWithValue(exc);
    }
  }
);

export const driverChangeStatusSliceRedux = createSlice({
  name: "driver/driverChangeStatus",
  initialState: INIT_STATE,
  reducers: {
    resetDriverChangeStatusState: (state, action) => {
      return action.payload
        ? { ...state, ...action.payload }
        : { ...INIT_STATE };
    },
    setOpenChangeStatus: (state, action) => {
      state.openChangeStatus = action.payload.open;
      state.items = action.payload.items;
    },
  },
  extraReducers: (builder) => {
    //changeStatusDriver
    builder.addCase(changeStatusDriver.pending, (state, action) => {
      state.loadingChangeStatusDriver = true;
    });
    builder.addCase(changeStatusDriver.fulfilled, (state, { payload }) => {
      state.loadingChangeStatusDriver = false;
      state.changeStatusResponse = payload;
    });
    builder.addCase(changeStatusDriver.rejected, (state, { payload }) => {
      state.loadingChangeStatusDriver = false;
      state.errorChangeStatusDriver = payload;
    });
  },
});

const { actions, reducer } = driverChangeStatusSliceRedux;

export const { resetDriverChangeStatusState, setOpenChangeStatus } = actions;

export default reducer;
